export default {
  description: {
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: 'normal',
    color: '#333333',
  },
};
